import cx from 'classnames';
import React from 'react';
import styles from '../card.module.scss';
export const CardBody = ({ children, className }) => (React.createElement("div", { className: cx(styles.cardSectionWrapper, className) }, children));
//# sourceMappingURL=card-body.js.map